import type { TranslationMessages } from '../../types';

export const leave: TranslationMessages = {
  title: 'Leave Requests',
  subtitle: 'Manage and request days off',
  request_button: 'Request Day Off',
  new_request_title: 'Submit Leave Request',
  new_request_desc: 'Fill in the details for your day off request.',
  type_label: 'Type',
  type_unpaid: 'Unpaid',
  type_paid: 'Paid',
  type_sick: 'Sick Leave',
  type_other: 'Other',
  reason_placeholder: 'Why do you need this day off?',
  no_requests: 'No leave requests found',
  type: 'Type',
  status_approved: 'Approved',
  status_rejected: 'Rejected',
  status_cancelled: 'Cancelled',
  status_pending: 'Pending',
  fetch_failed: 'Failed to load leave requests',
  create_success: 'Leave request submitted successfully',
  create_failed: 'Failed to submit leave request',
  approved_success: 'Leave request approved successfully',
  approved_failed: 'Failed to approve leave request',
  rejected_success: 'Leave request rejected successfully',
  rejected_failed: 'Failed to reject leave request',
  delete_success: 'Leave request deleted successfully',
  delete_failed: 'Failed to delete leave request',
  invalid_dates: 'End date cannot be before start date',
  rejection_reason_prompt: 'Enter rejection reason:',
};
